<template>
  <div>
    <!-- List Table -->
    <List
      :header="header"
      :data="data"
      :pagination="pagination"
      :loading="loading"
      @updatePage="updatePage"
    >
      <template v-slot:item.action="{ item }">
        <b-dropdown
          class="actions-button nomaxh"
          variant="dark"
          :text="$t('global.actions')"
        >
          <b-dropdown-item
            class="dropdownAlertLabel"
            @click.native="terminateOperation(item)"
            >{{ $t('servers.terminate') }}</b-dropdown-item
          >
        </b-dropdown>
      </template>
    </List>

    <div class="mt-2">
      <b-button
        type="button"
        @click="openCreateServiceManagement()"
        variant="primary"
        class="px-10 mt-5"
        >{{ $t('plusCloudsCs.createServiceManagement') }}</b-button
      >
    </div>

    <!-- Create Popup -->
    <DetailModal
      :title="$t(dynamicOperationComponentTitle)"
      :show="showDetail"
      @confirm="confirmModal()"
      @closeDetail="closeDetail()"
      :resetForm="resetForm"
    >
      <component
        v-if="dynamicOperationComponent != ''"
        :is="dynamicOperationComponent"
        :confirmModal="confirmCreate"
        @resetDetailForm="resetDetailForm"
      />
    </DetailModal>
  </div>
</template>

<script>
// Services
import ApiService from '@/core/services/api.service'

export default {
  name: 'ServiceManagementList',
  data() {
    return {
      loading: false,
      header: [
        { text: 'global.name', value: 'name' },
        { text: 'global.actions', value: 'action' },
      ],
      data: [],
      pagination: {},
      meta: {},
      showDetail: false,
      dynamicOperationComponentTitle: '',
      dynamicOperationComponent: '',
      confirmCreate: false,
      resetForm: false,
      deleteOperationUrl: '',
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true

      const { current_page } = this.meta
      let $query = `swarm/compute-pool/${
        this.$route.params.id
      }/service&position=id|DESC&page=${current_page ? current_page : 1}`

      ApiService.get($query)
        .then(({ data }) => {
          this.data = data.data
          this.pagination = data.meta ? data.meta.pagination : {}

          this.loading = false
        })
        .catch((err) => {
          console.log(err)
          this.data = []
          this.loading = false
        })
    },
    updatePage(value) {
      this.meta = value

      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
    openCreateServiceManagement() {
      this.dynamicOperationComponentTitle =
        'plusCloudsCs.createServiceManagement'
      this.dynamicOperationComponent = 'CreateServiceManagement'
      this.showDetail = true
    },
    closeDetail() {
      this.showDetail = false
      this.dynamicOperationComponentTitle = ''
      this.dynamicOperationComponent = ''
    },
    confirmModal() {
      this.confirmCreate = true
      setTimeout(() => {
        this.confirmCreate = false
      }, 200)
    },
    resetDetailForm(closeDetail = false) {
      if (closeDetail) {
        this.$generateToast(this, 'success', this.$t('global.successful'))
        this.closeDetail()
        this.getList()
      }

      this.resetForm = true
      setTimeout(() => {
        this.resetForm = false
      }, 200)
    },
    terminateOperation(item) {
      this.deleteOperationUrl = `swarm/compute-pool/${this.$route.params.id}/service/${item.id}`
      this.$bvModal.show('modal-deleteOperation')
    },
  },
  watch: {
    meta: {
      handler() {
        this.getList()
      },
      deep: true,
    },
  },
  components: {
    CreateServiceManagement: () =>
      import('@/components/forms/CreateServiceManagement'),
  },
}
</script>
